module.exports = __webpack_public_path__ + "img/img_sub_brand_02_img.e14bebfa.png";